module.exports ={
    help_center: 'Help center',
    go_to: 'Return UPlus',
    previous_page: 'Previous page',
    announcement_center: 'Notice Center',
    welcome_to_help_center: 'Welcome to the Help Center',
    anything:'Is there anything I can do for you?',
    getting_started_guide: 'Getting Started Guide',
    getting_started_guide_desc: 'Learn how to start cryptocurrency trading on UPlus',
    customer_service: 'Customer Service',
    customer_service_desc: 'If the problem persists, please contact customer service',
    faq: 'FAQ',
    faq_desc: 'Explanation of common problems encountered when using Uplus',
    view_all: 'View all',
    newbies_must_read: 'A must read for newbies',
    uplus_product_introduction: 'UPlus Product Introduction',
    exclusive_user_introduction: 'Exclusive user introduction',
    modify_strategy_position_description: 'Modify Strategy Position Description',
    stop_loss_instructions: 'Stop loss instructions',
    points_card_and_fuel_fee_explanation: 'Points Card and Fuel Fee Explanation',
    announcement: 'Notice',
    new_user_account: 'New user account activation and binding process',
    binance_api_binding_tutorial: 'Binance API Binding Tutorial',
    ouyi_api_binding_tutorial: 'Ouyi API Binding Tutorial',
    understanding_gold: 'Understanding Gold Triangle Arbitrage Trading',
    understand_bb_trading_in_seconds: 'Understand BB trading in seconds',
    understand_ub_trading_in_seconds: 'Understand UB Trading in Seconds',
    understand_grid_trading_in_seconds:'Understand grid strategy in seconds',
    understand_martingale_strategy: 'Understanding Martingale Strategy',
    tutorial_on: 'Tutorial on Activating Contract Quantitative Trading Permissions for EuroEasy Accounts',
    understand_hedging_contract: 'Understand hedging contract trading in seconds',
    all_read: 'All read',
    transaction_notification: 'Trading Notification',
    article: 'Article',
    system_notification: 'System notification',
    details: 'Details',
	to_UPlus:'Return to UPlus'
}
